import script from "./TutorsContactSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorsContactSection.vue?vue&type=script&setup=true&lang=js"

import "./TutorsContactSection.vue?vue&type=style&index=0&id=024e97c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LEGION\\Desktop\\SONNAR\\proiBueno\\virgen\\reppsoc-ppqy9-portaltuturesweb\\reppsoc-ppqy9-portaltuturesweb\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-024e97c2"]])

export default __exports__